export enum BtnAction {
    _Add = 'add',
    _Close = 'close'
}
export interface INFT {
    for_loan: boolean;
    on_loan: boolean;
    lazy_mint: boolean;
    _id: string;
    token_id: string;
    loan_details: any;
    collections: any;
    // Set by holding-assets when the live loan has a pending refinance request.
    is_refinance_requested?: boolean;
    refinance_request_id?: string | null;
}


export interface ISortOption {
    label: string;
    type: string;
    value: number;
    displayIfInSale: boolean; //Display Sort Option Only if Sale Filter is Applied.
}
export interface contarctArg {
    functionName: string,
    args: Array<any>,
    abiType: string
}

export enum CONTRACT_METHOD {
    EXCHANGE_CONTRACT = 1,
    LOAN_CONTRACT = 2,
    FACTORY_CONTRACT = 3
}

export interface platformFee {
    feePercentage: number;
    _fixedFeeAmount: number;
}
export interface loanPlatformFee {
    borrower_spread_fee: any,
    borrower_spread_fixed_amount: any,
    lender_spread_fee: any,
    lender_spread_fixed_amount: any
}
export interface loanRepayTypes {
    name: string,
    value: string,
    isEmi: boolean
}

export const loanRepayType: Array<loanRepayTypes> = [
    {
        name: "End of loan.",
        value: "end_of_time",
        isEmi: false
    },
    {
        name: "Monthly.",
        value: "monthly",
        isEmi: true
    }
]

export interface loanRequestParams {
    spread_fee: loanPlatformFee,
    borrower_id: any,
    requested_loan_amount: any,
    loan_percentage: any,
    loan_duration_days: any,
    interest_amount: any,
    total_amount: any,
    borrow_lend_contract: any,
    collateral_assets: any,
    currency_data: any,
    nonce: any,
    transaction_hash: any,
    gas_price: any,
    block_number: any,
}

export interface loanType {
    name: string,
    value: boolean,
}

export const loanType: Array<loanType> = [
    {
        name: "Yes.",
        value: false
    },
    {
        name: "No.",
        value: true
    }
]
